import React from 'react';

// Components

import BlockWrapper from '@components/hyperDashboard/blocks/BlockWrapper';

// Constants

import { flowTypes } from '@constants/ssap/flows/flowTypes';


// Styles

import { darculaAttestationsInfoStyles } from '../darculaTheme';

const {
    blockWrapperAdditionalStyles,
    titleBlockStyle,
    emphasisValueStyle,
    listContainerStyle,
    attestationRowStyle,
    attestationNameVisibleStyle,
    attestationNameHiddenStyle,
} = darculaAttestationsInfoStyles;

const AttestationInfo = props => {
    const {
        attestationsConfig = { },
        id,
        flowType,
        stateCode,
    } = props;

    const getAttestations = () => {
        if (!attestationsConfig[stateCode]) {
            return null;
        }
        return attestationsConfig[stateCode].map(attestation => {
            const { attestationName, isVisible = true } = attestation;

            return (
                <div key={attestationName} style={attestationRowStyle}>
                    <span style={isVisible ? attestationNameVisibleStyle : attestationNameHiddenStyle}>
                        {attestationName}
                    </span>
                </div>
            );
        });
    };

    return (
        <BlockWrapper id={id} additionalStyles={blockWrapperAdditionalStyles}>
            <div style={titleBlockStyle}>
                Rendered Attestations <br />
                State: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <strong style={emphasisValueStyle}>{stateCode}</strong> <br />
                Flow type: &nbsp; &nbsp; &nbsp;
                <strong style={emphasisValueStyle}>
                    {flowType === flowTypes.FINANCIAL_FLOW ? 'Financial' : 'Non-Financial'}
                </strong>
            </div>
            <div style={listContainerStyle}>{getAttestations()}</div>
        </BlockWrapper>
    );
};

export default AttestationInfo;